'use client';

import React from 'react';
import styles from './Security.module.css';

export interface SecurityRowProps {
  action?: React.ReactNode;
  children?: React.ReactNode;
  hint?: React.ReactNode;
  label?: string;
  tone?: 'default' | 'danger';
  value?: React.ReactNode;
  wrap?: boolean;
}

export function SecurityRow({ action, children, hint, label, tone = 'default', value, wrap = false }: SecurityRowProps) {
  const labelClassName =
    tone === 'danger' ? `acct-field-label ${styles.labelDanger}` : 'acct-field-label';

  return (
    <div className={wrap ? `${styles.row} ${styles.rowWrap}` : styles.row}>
      <div className={styles.rowMain}>
        {label ? <div className={labelClassName}>{label}</div> : null}
        {value !== undefined ? (
          <div className={tone === 'danger' ? `${styles.value} ${styles.valueDanger}` : styles.value}>{value}</div>
        ) : null}
        {hint ? <div className="acct-muted">{hint}</div> : null}
        {children}
      </div>
      {action}
    </div>
  );
}
